// extracted by mini-css-extract-plugin
module.exports = {"block":"block-f46ac9","icon":"icon-f46ac9","title":"title-f46ac9","pre":"pre-f46ac9","iconBlock":"iconBlock-f46ac9","text":"text-f46ac9","btns":"btns-f46ac9","btn":"btn-f46ac9"};